import { render } from "./ContentFooter.vue?vue&type=template&id=01c810c9"
import script from "./ContentFooter.vue?vue&type=script&lang=js"
export * from "./ContentFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/layout/ContentFooter.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "01c810c9"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('01c810c9', __exports__)) {
    api.reload('01c810c9', __exports__)
  }
  
  module.hot.accept("./ContentFooter.vue?vue&type=template&id=01c810c9", () => {
    api.rerender('01c810c9', render)
  })

}


export default __exports__